import { t } from "i18next";

export const tableStyles = {
    headCells: {
        style: {
            fontWeight: 'bold',
            color: '#ffffff',
            backgroundColor: '#91231F'
        },
    }
};

export const getPaginationOptions = () => ({
    rowsPerPageText: t("Rows per page:"),
    rangeSeparatorText: t("of")
});